class Entry {
  constructor(el, opt) {
    this.el = el;
    this.opt = opt || {};

    // DOMが読み込まれるまで待機してから初期化
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.init();
      });
    } else {
      this.init();
    }
  }

  init() {
    // IDとクラスの両方をチェック
    this.$target = $("." + this.el);

    if (this.$target.length > 0) {
      this.event();
    }
  }

  event() {
    const $target = this.$target;

    if ($target.length === 0) {
      return;
    }

    // ショートコードで取得したカスタムフィールドデータを確認
    // ポーリングで最大3秒間、archiveCustomFieldsが定義されるまで待つ
    let attempts = 0;
    const maxAttempts = 30;

    const checkArchiveCustomFields = () => {
      attempts++;

      try {
        if (
          typeof archiveCustomFields !== "undefined" &&
          archiveCustomFields !== null
        ) {
          this.initCustomFields(archiveCustomFields);
          return;
        }
      } catch (error) {
        // エラーは無視して続行
      }

      if (attempts < maxAttempts) {
        setTimeout(checkArchiveCustomFields, 100);
      } else {
        // データがなくてもフォームフィールドの検索は実行
        this.initFormFiltering();
      }
    };

    checkArchiveCustomFields();
  }

  initCustomFields(customFieldsData) {
    if (!customFieldsData || !Array.isArray(customFieldsData)) {
      return;
    }

    this.customFieldsData = customFieldsData;
    this.initFormFiltering();
  }

  initFormFiltering() {
    const $target = this.$target;

    // 応募種別のラジオボタンを探す
    const $applicationTypeRadios = $target.find(
      'input[type="radio"][name*="応募種別"], ' +
        'input[type="radio"][name*="application"], ' +
        'input[type="radio"][name*="type"]'
    );

    // 応募職種のセレクトボックスを探す（表示用 - CF7管理外）
    const $jobTypeSelect = $target.find(
      'select[name*="応募職種"], ' +
        'select[name*="job"], ' +
        'select[name*="職種"], ' +
        "#occupation, " +
        "select#occupation, " +
        'select[name="occupation-display"], ' +
        'select[name="occupation"], ' +
        'select[name*="occupation"]'
    );

    // CF7のhiddenフィールドと同期、バリデーション
    if ($jobTypeSelect.length > 0) {
      const $occupationHidden = $target.find('input[name="occupation"][type="hidden"]');
      const $form = $target.find('.wpcf7-form');
      
      if ($occupationHidden.length > 0) {
        const syncToHidden = () => {
          const selectedValue = $jobTypeSelect.val() || '';
          $occupationHidden.val(selectedValue);
        };
        $jobTypeSelect.on('change', syncToHidden);
        if ($form.length > 0) {
          $form.on('submit', function(e) {
            syncToHidden();
          });
          $(document).on('wpcf7beforesubmit', $form, function() {
            syncToHidden();
          });
        }
        setTimeout(syncToHidden, 100);
      }

      // バリデーション
      this.initJobTypeValidation($jobTypeSelect, $form);
    }

    // 生年月日フィールドの動的設定（20代が選択できるように）
    this.initBirthdayField($target);

    // URLパラメータから応募種別と応募職種を取得
    const urlParams = new URLSearchParams(window.location.search);
    const urlType = urlParams.get("type");
    const urlJob = urlParams.get("job");

    // 応募種別の選択が変更されたときの処理
    if ($applicationTypeRadios.length > 0 && $jobTypeSelect.length > 0) {
      // カスタムフィールドデータがある場合のみ、フィルタリング機能を有効化
      if (
        this.customFieldsData &&
        Array.isArray(this.customFieldsData) &&
        this.customFieldsData.length > 0
      ) {
        $applicationTypeRadios.on("change", (e) => {
          const selectedType = $(e.target).val();
          this.updateJobTypeOptions(selectedType, $jobTypeSelect);
        });

        // URLパラメータがある場合は、それに基づいて選択
        if (urlType) {
          const $urlTypeRadio = $applicationTypeRadios.filter(
            `[value="${urlType}"]`
          );
          if ($urlTypeRadio.length > 0) {
            $urlTypeRadio.prop("checked", true);
            this.updateJobTypeOptions(urlType, $jobTypeSelect, urlJob);
          } else {
            // 初期状態で選択されている応募種別がある場合は、それに応じて応募職種を更新
            const $selectedType = $applicationTypeRadios.filter(":checked");
            if ($selectedType.length > 0) {
              const selectedType = $selectedType.val();
              this.updateJobTypeOptions(selectedType, $jobTypeSelect);
            } else {
              this.clearJobTypeOptions($jobTypeSelect);
            }
          }
        } else {
          // 初期状態で選択されている応募種別がある場合は、それに応じて応募職種を更新
          const $selectedType = $applicationTypeRadios.filter(":checked");
          if ($selectedType.length > 0) {
            const selectedType = $selectedType.val();
            this.updateJobTypeOptions(selectedType, $jobTypeSelect);
          } else {
            this.clearJobTypeOptions($jobTypeSelect);
          }
        }
      }
    }
  }

  updateJobTypeOptions(selectedType, $jobTypeSelect, preselectedJobId = null) {
    if (!$jobTypeSelect || $jobTypeSelect.length === 0) {
      return;
    }

    if (!this.customFieldsData || !Array.isArray(this.customFieldsData)) {
      return;
    }

    // 応募種別とカスタムフィールドの親ターム名の対応関係
    const typeMapping = {
      新卒採用: "新卒採用",
      キャリア採用: "キャリア採用",
      インターンシップ: "インターンシップ",
    };

    // 選択された応募種別に対応する親ターム名を取得
    const mappedType = typeMapping[selectedType] || selectedType;
    const normalizeString = (str) => {
      if (!str) return "";
      return String(str).trim().toLowerCase();
    };

    const selectedTypeNormalized = normalizeString(mappedType);
    const originalTypeNormalized = normalizeString(selectedType);

    const selectedParent = this.customFieldsData.find((parent) => {
      const parentNameNormalized = normalizeString(parent.parent_term_name);
      const parentSlugNormalized = normalizeString(parent.parent_term_slug);

      // マッピング後の値で完全一致
      if (
        parentNameNormalized === selectedTypeNormalized ||
        parentSlugNormalized === selectedTypeNormalized
      ) {
        return true;
      }

      // 元の値でも完全一致を試す
      if (
        parentNameNormalized === originalTypeNormalized ||
        parentSlugNormalized === originalTypeNormalized
      ) {
        return true;
      }

      // 部分一致（どちらかが含まれている）
      if (
        parentNameNormalized.includes(selectedTypeNormalized) ||
        selectedTypeNormalized.includes(parentNameNormalized) ||
        parentSlugNormalized.includes(selectedTypeNormalized) ||
        selectedTypeNormalized.includes(parentSlugNormalized) ||
        parentNameNormalized.includes(originalTypeNormalized) ||
        originalTypeNormalized.includes(parentNameNormalized) ||
        parentSlugNormalized.includes(originalTypeNormalized) ||
        originalTypeNormalized.includes(parentSlugNormalized)
      ) {
        return true;
      }

      return false;
    });

    if (!selectedParent) {
      this.clearJobTypeOptions($jobTypeSelect);
      return;
    }

    // 既存の選択肢をクリア（全てクリア）
    $jobTypeSelect.empty();

    // 選択された応募種別に紐づく子ターム（応募職種）を取得
    if (selectedParent.children && Array.isArray(selectedParent.children)) {
      const addedDisplayNames = new Set(); // 重複チェック用
      const options = []; // 追加する選択肢を一時的に保存

      selectedParent.children.forEach((child) => {
        // 投稿がある子タームのみを表示
        if (
          child.posts &&
          Array.isArray(child.posts) &&
          child.posts.length > 0
        ) {
          // 各投稿のdisplay_nameを使用して選択肢を作成（【小要素名】recruit_titleの形式）
          child.posts.forEach((post) => {
            // display_nameが存在する場合はそれを使用、ない場合は生成
            const displayName =
              post.display_name ||
              `【${child.child_term_name}】${post.recruit_title || ""}`;

            // 重複を避ける
            if (!addedDisplayNames.has(displayName)) {
              addedDisplayNames.add(displayName);

              // CF7のメール返信文で使用するため、value属性にdisplay_nameを設定
              // タームIDもdata属性として保持（必要に応じて使用可能）
              const optionValue = displayName;

              const option = $("<option></option>")
                .attr("value", optionValue)
                .text(displayName)
                .data("term-id", child.child_term_id)
                .data("term-slug", child.child_term_slug)
                .data("category-color", child.category_color)
                .data("display-name", displayName)
                .data("grandchild-term-id", post.grandchild_term_id || 0)
                .data("grandchild-term-name", post.grandchild_term_name || "")
                .data("recruit-title", post.recruit_title || "");

              options.push(option);
            }
          });
        }
      });

      // 選択肢がある場合
      if (options.length > 0) {
        // プレースホルダーを追加
        $jobTypeSelect.append('<option value="">選択してください</option>');
        // 選択肢を追加
        options.forEach((option) => {
          $jobTypeSelect.append(option);
        });

        // URLパラメータで指定された応募職種を選択
        if (preselectedJobId) {
          const jobId = String(preselectedJobId);

          // まず、value属性で直接マッチングを試す（display_nameの場合）
          let $preselectedOption = $jobTypeSelect.find(
            `option[value="${jobId}"]`
          );

          // マッチしない場合、タームIDからdisplay_nameを探す
          if ($preselectedOption.length === 0) {
            // カスタムフィールドデータから該当する投稿を探す
            let targetDisplayName = null;

            if (
              selectedParent.children &&
              Array.isArray(selectedParent.children)
            ) {
              selectedParent.children.forEach((child) => {
                if (child.posts && Array.isArray(child.posts)) {
                  child.posts.forEach((post) => {
                    // タームIDが一致する投稿を探す
                    if (
                      String(post.grandchild_term_id) === jobId ||
                      String(child.child_term_id) === jobId
                    ) {
                      targetDisplayName =
                        post.display_name ||
                        `【${child.child_term_name}】${
                          post.recruit_title || ""
                        }`;
                    }
                  });
                }
              });
            }

            // display_nameが見つかった場合、それで選択
            if (targetDisplayName) {
              $preselectedOption = $jobTypeSelect.find(
                `option[value="${targetDisplayName.replace(/"/g, "&quot;")}"]`
              );
            }
          }

          if ($preselectedOption.length > 0) {
            $jobTypeSelect.val($preselectedOption.attr("value"));
          }
        }
      } else {
        // 選択肢が1つもない場合
        $jobTypeSelect.append('<option value="">募集要項がありません</option>');
      }
    } else {
      // 子タームが存在しない場合
      $jobTypeSelect.append('<option value="">募集要項がありません</option>');
    }

    // CF7のhiddenフィールドに同期（選択肢更新後）
    setTimeout(() => {
      this.syncToHiddenField($jobTypeSelect);
    }, 50);
  }

  clearJobTypeOptions($jobTypeSelect) {
    if (!$jobTypeSelect || $jobTypeSelect.length === 0) return;

    $jobTypeSelect.empty();
    $jobTypeSelect.append(
      '<option value="">応募種別を選択してください</option>'
    );

    // CF7のhiddenフィールドに同期
    this.syncToHiddenField($jobTypeSelect);
  }

  // CF7のhiddenフィールドに同期する関数
  syncToHiddenField($jobTypeSelect) {
    if (!$jobTypeSelect || $jobTypeSelect.length === 0) return;
    
    const selectedValue = $jobTypeSelect.val() || '';
    const $occupationHidden = $jobTypeSelect.closest('.wpcf7-form, .entry, body').find('input[name="occupation"][type="hidden"]');
    if ($occupationHidden.length > 0) {
      $occupationHidden.val(selectedValue);
    }
  }

  // 応募職種のバリデーション
  initJobTypeValidation($jobTypeSelect, $form) {
    const invalidValues = ['', '選択してください', '募集要項がありません'];
    let hasInteracted = false; // ユーザーが操作したかどうかのフラグ
    
    const validate = (showError = true, forceShow = false) => {
      const value = $jobTypeSelect.val() || '';
      const text = $jobTypeSelect.find('option:selected').text().trim();
      
      if (!value || invalidValues.includes(value) || invalidValues.includes(text)) {
        // エラーメッセージを表示する条件: 強制表示または（エラー表示が有効でユーザーが操作した場合）
        if (showError && (forceShow || hasInteracted)) {
          // エラーメッセージを表示する親要素を探す
          let $wrap = $jobTypeSelect.closest('.wpcf7-form-control-wrap');
          if ($wrap.length === 0) {
            $wrap = $jobTypeSelect.closest('label');
          }
          if ($wrap.length === 0) {
            $wrap = $jobTypeSelect.closest('p');
          }
          if ($wrap.length === 0) {
            $wrap = $jobTypeSelect.parent();
          }
          
          // 既存のエラーメッセージを削除してから新しく作成
          $wrap.find('.wpcf7-not-valid-tip').remove();
          
          const $error = $('<span class="wpcf7-not-valid-tip"></span>');
          $wrap.append($error);
          $error.text('選択してください。').css({
            'color': 'red',
            'font-size': '1.4rem',
            'display': 'block',
            'margin-top': '0.5rem'
          });
          $jobTypeSelect.addClass('wpcf7-not-valid');
          
          // フォーカスを当てる
          setTimeout(() => {
            if ($jobTypeSelect[0]) {
              $jobTypeSelect[0].focus();
            }
          }, 100);
        }
        return false;
      } else {
        // エラーメッセージを非表示
        let $wrap = $jobTypeSelect.closest('.wpcf7-form-control-wrap, label, p');
        if ($wrap.length === 0) $wrap = $jobTypeSelect.parent();
        $wrap.find('.wpcf7-not-valid-tip').hide();
        $jobTypeSelect.removeClass('wpcf7-not-valid');
        return true;
      }
    };

    // 選択変更時（間違ったものを選んだ時も含む）
    $jobTypeSelect.on('change', function() {
      hasInteracted = true;
      validate(true, false); // エラーメッセージを表示
    });
    
    // フォーム送信時のバリデーション
    const $target = $jobTypeSelect.closest('.entry, .wpcf7, body');
    
    // 送信ボタンのクリックイベントをフック（複数の方法で確実に）
    const handleSubmit = function(e) {
      const isValid = validate(true, true); // 強制表示
      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
      }
    };
    
    // ネイティブイベント（キャプチャフェーズ）
    const $submitBtn = $target.find('.wpcf7-submit');
    if ($submitBtn.length > 0) {
      $submitBtn.each(function() {
        this.addEventListener('click', handleSubmit, true);
      });
    }
    
    // jQueryでもフック（委譲イベントで動的に追加される要素にも対応）
    $target.on('click', '.wpcf7-submit', handleSubmit);
    
    // フォーム送信イベントもフック
    if ($form.length > 0) {
      $form.on('submit', handleSubmit);
      $(document).on('wpcf7beforesubmit', $form, function(e) {
        const isValid = validate(true, true);
        if (!isValid) {
          e.preventDefault();
          return false;
        }
      });
    }
    
    // 動的に追加される送信ボタンにも対応（MutationObserverまたは定期的なチェック）
    const checkSubmitButton = () => {
      const $newSubmitBtn = $target.find('.wpcf7-submit').not('[data-validation-bound]');
      if ($newSubmitBtn.length > 0) {
        $newSubmitBtn.each(function() {
          $(this).attr('data-validation-bound', 'true');
          this.addEventListener('click', handleSubmit, true);
        });
      }
    };
    
    // 定期的にチェック（動的に追加されるボタンに対応）
    setInterval(checkSubmitButton, 500);
    setTimeout(checkSubmitButton, 1000);
  }

  // 生年月日フィールドの動的設定（20代が選択できるように）
  initBirthdayField($target) {
    // 生年月日フィールドを探す
    const $birthdayField = $target.find(
      'input[type="date"][name*="birthday"], ' +
      'input[type="date"][name="birthday"]'
    );

    if ($birthdayField.length === 0) {
      return;
    }

    // 今日の日付を取得
    const today = new Date();
    
    // 20代の範囲を計算
    // 最大値: 今日の日付
    const maxDate = new Date(today);
    
    // 最小値: 今日から100年前の01月01日（カレンダーで過去方向に100年遡れるように）
    const minDate = new Date(today);
    minDate.setFullYear(today.getFullYear() - 100);
    minDate.setMonth(0); // 0 = 1月
    minDate.setDate(1); // 1日

    // カレンダーを開いたときの初期表示位置: 20年前の01月01日
    const initialViewDate = new Date(today);
    initialViewDate.setFullYear(today.getFullYear() - 20);
    initialViewDate.setMonth(0); // 0 = 1月
    initialViewDate.setDate(1); // 1日

    // YYYY-MM-DD形式に変換
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const maxDateStr = formatDate(maxDate);
    const minDateStr = formatDate(minDate);
    const initialViewDateStr = formatDate(initialViewDate);

    // 各生年月日フィールドに設定
    $birthdayField.each(function() {
      const $field = $(this);
      const fieldElement = this;
      $field.attr('max', maxDateStr);
      $field.attr('min', minDateStr);

      // カレンダーを開いたときに20年前の1月1日が表示されるように設定
      let isInitializing = false;

      // フィールドがクリックされたとき（カレンダーを開く前）
      $field.on('mousedown', function(e) {
        if (!$field.val() && !isInitializing) {
          isInitializing = true;
          // 一時的に初期表示用の日付を設定
          $field.val(initialViewDateStr);
          // カレンダーが開いた後に、値が選択されていない場合はクリア
          setTimeout(() => {
            if ($field.val() === initialViewDateStr) {
              // ユーザーが何も選択していない場合、値をクリア
              // ただし、カレンダーが開いている間は値を保持
              const checkValue = setInterval(() => {
                if (!$field.is(':focus') && $field.val() === initialViewDateStr) {
                  $field.val('');
                  clearInterval(checkValue);
                  isInitializing = false;
                } else if ($field.val() !== initialViewDateStr) {
                  clearInterval(checkValue);
                  isInitializing = false;
                }
              }, 100);
              // 5秒後に強制的にクリア（安全策）
              setTimeout(() => {
                clearInterval(checkValue);
                if ($field.val() === initialViewDateStr && !$field.is(':focus')) {
                  $field.val('');
                }
                isInitializing = false;
              }, 5000);
            } else {
              isInitializing = false;
            }
          }, 200);
        }
      });

      // フォーカス時にも同様の処理（キーボード操作に対応）
      $field.on('focus', function() {
        if (!$field.val() && !isInitializing) {
          isInitializing = true;
          $field.val(initialViewDateStr);
          setTimeout(() => {
            if ($field.val() === initialViewDateStr) {
              const checkValue = setInterval(() => {
                if (!$field.is(':focus') && $field.val() === initialViewDateStr) {
                  $field.val('');
                  clearInterval(checkValue);
                  isInitializing = false;
                } else if ($field.val() !== initialViewDateStr) {
                  clearInterval(checkValue);
                  isInitializing = false;
                }
              }, 100);
              setTimeout(() => {
                clearInterval(checkValue);
                if ($field.val() === initialViewDateStr && !$field.is(':focus')) {
                  $field.val('');
                }
                isInitializing = false;
              }, 5000);
            } else {
              isInitializing = false;
            }
          }, 200);
        }
      });
    });
  }
}